
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import store from "./../../store";
import { systemSrv } from "./../../services/system";
import { cacheSrv } from "./../../services/cache";

import router from '@/router';
import QRCode from '@/components/common/QRCode.vue'

@Component({components:{QRCode}})
export default class SideMenu extends Vue {
  isOpen=false// = cacheSrv.cached("menuopen")
  windowWidth
  profile = systemSrv.profile;
  name=""
  created() {
    store.commit("setMenu", true);
    this.windowWidth = document.documentElement.clientWidth;
    this.adjustSideMenu()
    
    //Almir; disableed on 29th Oct 2019
    //window.addEventListener('resize', this.getWindowWidth);

    if(this.profile && this.profile['name']){
      this.name = this.profile['name']
    }
  }
  goTo(name){
    //console.log("name", name)
    router.push(name);
    if(this.windowWidth<960 && this.isOpen==true){
      store.commit("setMenu", false);
      
    }
  }
  getWindowWidth(x){
    this.windowWidth = document.documentElement.clientWidth;
    this.adjustSideMenu()
  }
  adjustSideMenu(){
    if(this.windowWidth<960){
      //console.log("1")
      store.commit("fixMenu", false);
      store.commit("setMenu", false);
      //store.commit("disableMenu", true);
    }
    else{
      //console.log("2")
      store.commit("fixMenu", true);
      store.commit("setMenu", true);
      //store.commit("disableMenu", false);
    }
    if(this.windowWidth<960 && this.isOpen==true){
      //console.log("3")
      store.commit("setMenu", false);
    }
    if(this.windowWidth>960 && this.isOpen==false){
      //console.log("4")
      store.commit("setMenu", true);
    }
  }

  get menuOpen() {
    //console.log("menuOpen", this.isOpen, store.state.menu.open)
    this.isOpen = store.state.menu.open
    return store.state.menu.open;
  }
  closeMenu() {
    store.commit("setMenu", false);
  }
}
